import { connect } from 'react-redux'

import { updateStart  } from '../actions'
import Start from '../component/Start'

const mapStateToProps = state => {
    return {
        start: state.start,
        activeStep: state.activeStep
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateStart: (start) => dispatch(updateStart(start)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (Start);
